export const mobileNavToggle = () => {
  const btn = document.getElementById('mobile-menu-btn');
  const menu = document.getElementById('mobile-menu');
  const iconMenu = document.getElementById('icon-menu');
  const iconClose = document.getElementById('icon-close');
  const mobileLinks = document.querySelectorAll('.mobile-link');

  // The landing page has its own nav and none of these elements.
  if (!btn || !menu || !iconMenu || !iconClose) return;

  // Toggle menu
  btn.addEventListener('click', () => {
    menu.classList.toggle('hidden');
    iconMenu.classList.toggle('hidden');
    iconClose.classList.toggle('hidden');
  });

  // Close menu when clicking a link
  mobileLinks.forEach((link) => {
    link.addEventListener('click', () => {
      menu.classList.add('hidden');
      iconMenu.classList.remove('hidden');
      iconClose.classList.add('hidden');
    });
  });
};
